import { Injectable } from '@angular/core';
import { EditableFieldComponent } from 'components/input/custom-input/editable-field.component';

@Injectable()
export class WorkspaceService {
	private _activeEditableField: EditableFieldComponent | null = null;

	get activeEditableField(): EditableFieldComponent | null {
		return this._activeEditableField;
	}

	set activeEditableField(value: EditableFieldComponent | null) {
		this._activeEditableField = value;
	}
}
